<template>
  <div>
    <Map_4G />
    <!-- <br> -->
    <Table_4G />
  </div>
</template>

<script>
// import {
//   BRow, BCol,
// } from 'bootstrap-vue'
// eslint-disable-next-line camelcase
import Map_4G from '@/views/lighting/total/4GMap.vue'
// eslint-disable-next-line camelcase
import Table_4G from '@/views/lighting/total/4GTable.vue'
// import axios from '@axios'
export default {
  components: {
    // BRow,
    // BCol,
    Map_4G,
    Table_4G,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style>
</style>
